module.exports = __webpack_public_path__ + "static/media/Garantia-03.e66fe924.svg";